interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export default function SectionHeading({ eyebrow, title, description, action }: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6 md:mb-8">
      <div>
        {eyebrow && (
          <span className="inline-block text-xs font-label font-semibold tracking-[0.2em] uppercase text-accent-600 mb-2">
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">{title}</h2>
        {description && (
          <p className="text-sm text-foreground-600 mt-1.5 max-w-2xl">{description}</p>
        )}
      </div>
      {action}
    </div>
  );
}